import axios from "axios";
import Const from "./consts";
import BasicService from "./basic.service";

class ApiAssets extends BasicService {
  api = Const.api + Const.path.assets;

  get(assetline) {
    return axios.get(this.api + `?asset_line=${assetline}`);
  }

  getOnlyLander(assetline) {
    return axios.get(this.api + `?asset_line=${assetline}&only_landers=true`);
  }

  putMessage(assetline, message) {
    return axios.put(this.api + `?asset_line=${assetline}`, {
      message
    });
  }

  getOnSale() {
    return axios.get(this.api + "?on_sale=true");
  }

  getMy(id) {
    const query = id ? `?uid=${id}` : ''; 
    return axios.get(this.api + '/my' + query);
  }

}

export default new ApiAssets();



// WEBPACK FOOTER //
// ./src/utils/api.assets.js